/**
 * Réglages des tarifs : saisie avant taxes ou taxes incluses (on garde toujours le prix avant taxes en base),
 * et où et comment payer (accueil, en ligne, borne…).
 */
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { saveTariffSettings } from '../../api'
import { errorText, type TabProps } from './common'

export function SettingsTab({ orgId, data, onSaved }: TabProps) {
  const { t } = useTranslation('gestion')
  const [includeTax, setIncludeTax] = useState(data.settings.prices_include_tax)
  const [paymentNote, setPaymentNote] = useState(data.settings.payment_note)
  const [busy, setBusy] = useState(false)
  const [saved, setSaved] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const save = async () => {
    setBusy(true)
    setError(null)
    setSaved(false)
    try {
      onSaved(await saveTariffSettings(orgId, { prices_include_tax: includeTax, payment_note: paymentNote }))
      setSaved(true)
    } catch (e) {
      setError(errorText(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <fieldset className="g-field">
        <span className="g-field__label">{t('tarifs.saisie_titre')}</span>
        <label className="g-check">
          <input type="radio" name="tarifs-taxes" checked={!includeTax} onChange={() => setIncludeTax(false)} />
          <span>{t('tarifs.saisie_option_ht')}</span>
        </label>
        <label className="g-check">
          <input type="radio" name="tarifs-taxes" checked={includeTax} onChange={() => setIncludeTax(true)} />
          <span>{t('tarifs.saisie_option_ttc')}</span>
        </label>
        <span className="g-muted">{t('tarifs.saisie_aide')}</span>
      </fieldset>
      <label className="g-field">
        <span className="g-field__label">{t('tarifs.paiement')}</span>
        <textarea className="g-input" rows={3} value={paymentNote} placeholder={t('tarifs.paiement_exemple')} onChange={(e) => setPaymentNote(e.target.value)} />
      </label>
      <div className="g-editor__buttons">
        <button type="button" className="btn btn--primary" disabled={busy} onClick={() => void save()}>
          {busy ? t('commun.enregistrement') : t('commun.enregistrer')}
        </button>
        {saved && <span className="g-muted">{t('commun.enregistre')}</span>}
      </div>
      {error && <p className="g-alert g-alert--error">{error}</p>}
    </>
  )
}
